import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useChUpdateMeasLaboratoryPrescriptionMutation as useChUpdateMeasLaboratoryPrescriptionMutationType } from "@/modules/patients/detail/meas-laboratory-prescription/ch/services/__generated__/useChUpdateMeasLaboratoryPrescriptionMutation.graphql"

const mutation = graphql`
  mutation useChUpdateMeasLaboratoryPrescriptionMutation($input: Ch_updateMeasLaboratoryPrescriptionInput!) {
    ch_updateMeasLaboratoryPrescription(input: $input) {
      ch_MeasLaboratoryPrescription {
        id
        ...chMeasLaboratoryPrescriptionFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useChUpdateMeasLaboratoryPrescriptionMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useChUpdateMeasLaboratoryPrescriptionMutationType>(
    mutation,
    params,
  )

  const commitHandler = useCallback(
    (config: UseMutationConfig<useChUpdateMeasLaboratoryPrescriptionMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChUpdateMeasLaboratoryPrescriptionMutation }
